import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ezGolf-footer pt-2 mt-3" }
const _hoisted_2 = { class: "clearfix mb-0" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "float-md-left d-block d-md-inline-block mt-25 m-lg-2" }, " Powered by ezCloud ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavigationHeaderVue = _resolveComponent("NavigationHeaderVue")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_NavigationHeaderVue, {
      class: "mb-2",
      componentActive: $setup.urlProps
    }, null, 8, ["componentActive"]),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("footer", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, [
        _createElementVNode("span", { innerHTML: $setup.footer }, null, 8, _hoisted_3),
        _hoisted_4
      ])
    ])
  ]))
}